interface BankList {
  bankName: string;
  shortName: string;
  bankCode: string;
  isActive: boolean;
}

export const bankList: BankList[] = [
  { bankName: "กรุงเทพ", shortName: "BBL", bankCode: "002", isActive: true },
  { bankName: "กสิกรไทย", shortName: "KBANK", bankCode: "004", isActive: true },
  { bankName: "กรุงไทย", shortName: "KTB", bankCode: "006", isActive: true },
  { bankName: "เจพีมอร์แกน", shortName: "JPM", bankCode: "008", isActive: true },
  { bankName: "โอเวอร์ซี-ไชนีส", shortName: "OCBC", bankCode: "009", isActive: true },
  { bankName: "ทีเอ็มบีธนชาต", shortName: "TTB", bankCode: "011", isActive: true },
  { bankName: "ไทยพาณิชย์", shortName: "SCB", bankCode: "014", isActive: true },
  { bankName: "ซิตี้แบงก์", shortName: "CITI", bankCode: "017", isActive: true },
  { bankName: "ซูมิโตโม มิตซุย แบงกิ้ง", shortName: "SMBC", bankCode: "018", isActive: true },
  { bankName: "สแตนดาร์ดชาร์เตอร์ต", shortName: "SCBT", bankCode: "020", isActive: true },
  { bankName: "ซีไอเอ็มบี", shortName: "CIMBT", bankCode: "022", isActive: true },
  { bankName: "อาร์ เอช บี", shortName: "RHB", bankCode: "023", isActive: true },
  { bankName: "ยูโอบี", shortName: "UOBT", bankCode: "024", isActive: true },
  { bankName: "กรุงศรี", shortName: "BAY", bankCode: "025", isActive: true },
  { bankName: "เมกะ", shortName: "MEGA", bankCode: "026", isActive: true },
  { bankName: "ธนาคารแห่งอเมริกา", shortName: "BANA", bankCode: "027", isActive: true },
  { bankName: "อินเดียน โอเวอร์ซีส์", shortName: "IOB", bankCode: "029", isActive: true },
  { bankName: "ออมสิน", shortName: "GSB", bankCode: "030", isActive: true },
  { bankName: "เอชเอสบีซี", shortName: "HSBC", bankCode: "031", isActive: true },
  { bankName: "ดอยซ์แบงก์", shortName: "DB", bankCode: "032", isActive: true },
  { bankName: "อาคารสงเคราะห์", shortName: "GHB", bankCode: "033", isActive: true },
  { bankName: "ธ.ก.ส.", shortName: "BAAC", bankCode: "034", isActive: true },
  { bankName: "เอ็กซิมแบงก์", shortName: "EXIM", bankCode: "035", isActive: true },
  { bankName: "มิซูโฮ", shortName: "Mizuho", bankCode: "039", isActive: true },
  { bankName: "บีเอ็นพี พารีบาส์", shortName: "BNPP", bankCode: "045", isActive: true },
  { bankName: "ธนาคารแห่งประเทศจีน", shortName: "BOC", bankCode: "052", isActive: true },
  { bankName: "อิสลาม", shortName: "ISBT", bankCode: "066", isActive: true },
  { bankName: "ทิสโก้", shortName: "TISCO", bankCode: "067", isActive: true },
  { bankName: "เกียรตินาคินภัทร", shortName: "KKP", bankCode: "069", isActive: true },
  { bankName: "ไอซีบีซี (ไทย)", shortName: "ICBC", bankCode: "070", isActive: true },
  { bankName: "ไทยเครดิต", shortName: "TCRB", bankCode: "071", isActive: true },
  { bankName: "แลนด์ แอนด์ เฮ้าส์", shortName: "LH BANK", bankCode: "073", isActive: true },
  { bankName: "ซูมิโตโม มิตซุย ทรัสต์", shortName: "SMTB", bankCode: "080", isActive: true },
  { bankName: "เอสเอ็มอีแบงก์", shortName: "SME", bankCode: "098", isActive: true },
]